import styled from "@emotion/styled";

import { ReactComponent as IconeBrilhos } from "../../../../assets/icons/ia_brilhos.svg";

export const Botao = styled.button`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: ${({ $compacto }) => ($compacto ? "36px" : "40px")};
  height: ${({ $compacto }) => ($compacto ? "36px" : "40px")};
  border: none;
  border-radius: 8px;
  cursor: pointer;
  overflow: hidden;
  color: ${({ theme }) => theme.cores.actionActive};
  background-color: ${({ theme }) => theme.cores.surface4};

  &:hover {
    filter: brightness(0.96);
  }

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.cores.brand40Default};
    outline-offset: 2px;
  }
`;

export const Brilhos = styled(IconeBrilhos)`
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
`;

export const TextoIA = styled.span`
  position: relative;
  font-size: 15px;
  font-weight: 700;
`;
